module.exports = __webpack_public_path__ + "static/media/madomi-grande-sf.ef1d70a3.png";